import DealerHours from 'lib/DealerHours';

export default class DealerPageEntity {
  constructor(attributes) {
    Object.assign(this, attributes);
  }

  get averageRating() {
    const ratings = this.reviews.map((review) => review.overall_rating);
    const total = ratings.reduce((acc, review) => acc + review, 0);
    return total / ratings.length;
  }

  get hours() {
    return new DealerHours(this.dealer.dealer_hours);
  }
}
